// extracted by css-extract-rspack-plugin
export default {"setkaContainer":"setka-container--plIFcFCOshwzwgkW","setkaQr":"setka-qr--n940eZcp8GY0x9gZ"};